var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6597 4.16492H3.33195C2.41185 4.16492 1.66597 4.9108 1.66597 5.83089V14.1608C1.66597 15.0808 2.41185 15.8267 3.33195 15.8267H16.6597C17.5798 15.8267 18.3257 15.0808 18.3257 14.1608V5.83089C18.3257 4.9108 17.5798 4.16492 16.6597 4.16492Z",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66597 8.32986H18.3257",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9917,
    height: 19.9917,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/Payments.65d329716a8aa22eab7261d9efc63e62.svg";
export { ForwardRef as ReactComponent };